import React from 'react';
import Content from './Content';
import styled from "styled-components";

const Wrapper = styled.div`
  z-index: 2;
  overflow: hidden;
  position: fixed;
  top: 3rem;
  right: 3rem;
  width: 32.2rem;
  background: ${({ theme }) => theme.backgroundColor.locationModal.modal};
  color: ${({ theme }) => theme.textColor.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    display: none;
  }
`;

const ObliquesModal = (props) => {
  const { info, handleToggleModal } = props;

  return (
    <Wrapper>
      <Content info={info} handleToggleModal={handleToggleModal} />
    </Wrapper>
  );
};

export default ObliquesModal;